export default "<div id=\"app\" class=\"w-100\">\n    <router-outlet></router-outlet>\n</div>"